(function () {
  function initBar(bar) {
    if (bar.__stickyInit) return;
    bar.__stickyInit = true;

    var selector = bar.getAttribute('data-sticky-watch') || '';
    var targets = [];
    if (selector) {
      try {
        targets = Array.prototype.slice.call(document.querySelectorAll(selector));
      } catch (e) {
        targets = [];
      }
    }

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    if (targets.length === 0 || !('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    var visible = Object.create(null);
    var idx = 0;

    function refresh() {
      var anyVisible = false;
      for (var k in visible) {
        if (visible[k]) { anyVisible = true; break; }
      }
      setVisible(!anyVisible);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var key = entry.target.__stickyKey;
        visible[key] = entry.isIntersecting && entry.intersectionRatio > 0;
      });
      refresh();
    }, { threshold: 0 });

    targets.forEach(function (el) {
      el.__stickyKey = 's' + (idx++);
      visible[el.__stickyKey] = false;
      io.observe(el);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sticky-cta]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
